import GuaranteedRentPage from "@/pages/guaranteed-rent/GuaranteedRentPage";
import { getCity } from "@/pages/guaranteed-rent/cityConfig";

export default function GuaranteedRentSheffield() {
  return <GuaranteedRentPage city={getCity("sheffield")} />;
}